import {IntermediatePart} from "../../intermediatePart";
import {PLACEMENTS} from "../../constants";

export default class Faucet extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'center_island_faucet';
    this.partName = 'Faucet';
    this.translateId = "visualizer.kitchen.center_island.center_island_faucet";
    this.canBeDisabled = true;
    if (isChild) {
      this.shouldLoadInMultipleGroups = true;
    }
  }

  load(dbFeature) {
    // dbFeature.metaData["RoomLayout"] = (dbFeature.metaData["RoomLayout"] && dbFeature.metaData["RoomLayout"].filter(roomLayout => roomLayout.includes("I"))) || [];
    if (dbFeature.s3Bindings && dbFeature.metaData && (!dbFeature.metaData["Placement"]
      || !dbFeature.metaData["Placement"].includes(PLACEMENTS.Island))) {
      return false
    }
    return super.load_(dbFeature, new Faucet());
  }

  disabledClick() {
    const centerIslandParent = this.getParent();
    const relatedSink = centerIslandParent.sink;
    if (relatedSink) {
      relatedSink.disabled = this.disabled;
    }
    const stovetop = centerIslandParent.stovetop;
    if (stovetop && !this.disabled && !stovetop.disabled) {
      stovetop.disabled = true;
    }
    const range = centerIslandParent.range;
    if (range && !this.disabled && !range.disabled) {
      range.disabled = true;
    }
  }

  // getArrayOfConditions() {
  //   const sink = this.getParent().sink;
  //   if (sink && sink.activeFeature) {
  //     return [{
  //       propName: "FaucetPlacement",
  //       propValue: sink.activeFeature.metaData["FaucetPlacement"] || "Moved"
  //     }]
  //   }
  //   return [];
  // }

  tryToSetTheSameFeature(filteredFeatures = [], partName = "") {
    if (this.activeFeature && this.activeFeature.partName) {
      const splittedName = (partName || this.activeFeature.partName).split(" M")[0];
      this.activeFeature = filteredFeatures.find(feature => {
        if (feature.partName) {
          const splittedCurrentName = feature.partName.split(" M")[0];
          return splittedCurrentName === splittedName
        }
        return false
      });
      // console.log('AF', filteredFeatures, this.activeFeature);
      if (this.activeFeature) {
        return true
      }
    }
    return false
  }

}
